"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by inf011 on 15/08/2016.
 */

var mobx_1 = require("mobx");

var MenuState =
/** @class */
function () {
  function MenuState() {
    var _this = this;

    this.hiHaDrawer = false;
    this.drawerFoldedWidth = 56;
    this.drawerUnfoldedWidth = 252;
    this.drawerVariant = 'temporary';
    this.openedDrawer = sessionStorage.getItem('menuState.openedDrawer') === '1';
    this.foldableDrawer = false;
    this.foldedDrawer = sessionStorage.getItem('menuState.foldedDrawer') !== '0';

    this.setHiHaDrawer = function (hiHa) {
      _this.hiHaDrawer = hiHa;
    };

    this.setDrawerVariant = function (variant) {
      if (variant) {
        _this.drawerVariant = variant;

        _this.setFoldableDrawer(variant === 'foldable');
      }
    };

    this.toogleDrawer = function () {
      _this.openedDrawer = !_this.openedDrawer;
      sessionStorage.setItem('menuState.openedDrawer', _this.openedDrawer ? '1' : '0');

      if (_this.foldableDrawer) {
        _this.foldedDrawer = !_this.openedDrawer;
        sessionStorage.setItem('menuState.foldedDrawer', _this.foldedDrawer ? '1' : '0');
      }
    };

    this.changeDrawer = function (open) {
      _this.openedDrawer = open;
      sessionStorage.setItem('menuState.openedDrawer', _this.openedDrawer ? '1' : '0');

      if (_this.foldableDrawer) {
        _this.foldedDrawer = !open;
        sessionStorage.setItem('menuState.foldedDrawer', _this.foldedDrawer ? '1' : '0');
      }
    };

    this.toogleFold = function () {
      if (_this.foldableDrawer) {
        _this.foldedDrawer = !_this.foldedDrawer && !_this.openedDrawer;
      }
    };

    this.changeFold = function (folded) {
      if (_this.foldableDrawer) {
        _this.foldedDrawer = folded;
      }
    };

    this.setFoldableDrawer = function (foldable) {
      _this.foldableDrawer = foldable;
    };
  }

  Object.defineProperty(MenuState.prototype, "drawerWidth", {
    get: function get() {
      return this.foldableDrawer && this.foldedDrawer ? this.drawerFoldedWidth : this.drawerUnfoldedWidth;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MenuState.prototype, "marginDrawer", {
    get: function get() {
      if (this.drawerVariant === 'permanent') {
        return 1 + this.drawerUnfoldedWidth;
      } else if (this.drawerVariant === 'foldable') {
        return 1 + (this.openedDrawer ? this.drawerUnfoldedWidth : this.drawerFoldedWidth);
      }

      return 0;
    },
    enumerable: true,
    configurable: true
  });

  __decorate([mobx_1.observable], MenuState.prototype, "hiHaDrawer", void 0);

  __decorate([mobx_1.observable], MenuState.prototype, "drawerFoldedWidth", void 0);

  __decorate([mobx_1.observable], MenuState.prototype, "drawerUnfoldedWidth", void 0);

  __decorate([mobx_1.observable], MenuState.prototype, "drawerVariant", void 0);

  __decorate([mobx_1.observable], MenuState.prototype, "openedDrawer", void 0);

  __decorate([mobx_1.observable], MenuState.prototype, "foldableDrawer", void 0);

  __decorate([mobx_1.observable], MenuState.prototype, "foldedDrawer", void 0);

  __decorate([mobx_1.computed], MenuState.prototype, "drawerWidth", null);

  __decorate([mobx_1.computed], MenuState.prototype, "marginDrawer", null);

  __decorate([mobx_1.action], MenuState.prototype, "setHiHaDrawer", void 0);

  __decorate([mobx_1.action], MenuState.prototype, "setDrawerVariant", void 0);

  __decorate([mobx_1.action], MenuState.prototype, "toogleDrawer", void 0);

  __decorate([mobx_1.action], MenuState.prototype, "changeDrawer", void 0);

  __decorate([mobx_1.action], MenuState.prototype, "toogleFold", void 0);

  __decorate([mobx_1.action], MenuState.prototype, "changeFold", void 0);

  __decorate([mobx_1.action], MenuState.prototype, "setFoldableDrawer", void 0);

  return MenuState;
}();

exports.default = MenuState;